import React, { useMemo } from 'react';
import PageLayout from '../../../components/common/PageLayout';
import Hero from '../../../components/common/Hero';
import Box from '../../../components/common/Box';
import { ConnectNetSuiteForm } from '../../../components/forms/ConnectNetSuiteForm';

export function ConnectNetSuiteWarehouseContainer() {
  const hero = useMemo(() => <Hero title="Connect Your NetSuite Account" />, []);

  return (
    <PageLayout top={hero}>
      <div style={{ width: 600, margin: '0 auto' }}>
        <Box>
          <ConnectNetSuiteForm />
        </Box>
      </div>
    </PageLayout>
  );
}
